import { render, staticRenderFns } from "./suspension-panel.vue?vue&type=template&id=142fca1b&scoped=true"
import script from "./suspension-panel.vue?vue&type=script&lang=js"
export * from "./suspension-panel.vue?vue&type=script&lang=js"
import style0 from "./suspension-panel.vue?vue&type=style&index=0&id=142fca1b&prod&lang=scss&scoped=true"
import style1 from "./suspension-panel.vue?vue&type=style&index=1&id=142fca1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142fca1b",
  null
  
)

export default component.exports